// Prefixes every key this app (tenant portal, "FE") writes to localStorage/
// sessionStorage, so it can't collide with the admin portal ("AFE") if both
// are ever served from the same origin.
const PREFIX = 'fe_';

export const STORAGE_KEYS = {
  ACCESS_TOKEN: `${PREFIX}accessToken`,
  TOKEN_EXPIRES_AT: `${PREFIX}token_expires_at`,
  PROCESSING_INVITATION: `${PREFIX}processing_invitation`,
  AUTH0_LOGOUT_FORCED: `${PREFIX}auth0_logout_forced`,
  AUTH_FAILURE_COUNT: `${PREFIX}auth_failure_count`,
  INITIAL_AUTH_PHASE: `${PREFIX}initial_auth_phase`,
} as const;
